import { DEFAULT_GRID_COLUMNS } from "@salestrak/ui";

import type { ManagedWidget } from "#app/widgets/dashboards/managed-widgets";

/**
 * Pure helpers for MANAGED surfaces (My Work, Team Overview): the half/full
 * width rhythm their catalogs are SEEDED on. The rhythm is a design of the
 * default layout and the vocabulary of the width menu's presets — it is not a
 * constraint on what an editor may drag a card to afterward. A resize commits
 * at the width the pointer left it, bounded only by the definition's span, the
 * same as on a free dashboard. A widget that must hold one width says so in
 * its own span (`minW === maxW`); nothing at the board level pins widths.
 */

// Must match WidgetGrid's default; dashboard grids never pass a columns prop.
// Derived from the library grid default so half/full width stay in lockstep
// with the grid's real column count (D12).
export const FULL_WIDTH = DEFAULT_GRID_COLUMNS;
export const HALF_WIDTH = DEFAULT_GRID_COLUMNS / 2;
export const HALF_FULL_WIDTH_OPTIONS = [
  { value: HALF_WIDTH, label: "Half width" },
  { value: FULL_WIDTH, label: "Full width" },
];

/** A catalog designed entirely on the half/full rhythm offers the Half/Full
 *  width presets in every card's menu — instant sizes beside the drag. */
export function usesHalfFullWidths(catalog?: ManagedWidget[]): boolean {
  return Boolean(
    catalog?.length && catalog.every((widget) => widget.w === HALF_WIDTH || widget.w === FULL_WIDTH),
  );
}
